import { UAParser } from 'ua-parser-js';
import { EBrowserType } from '../data/Constants';

const parser = new UAParser();
const parserResults = parser.getResult();
export function isChrome(): boolean {
  return (
    parserResults.browser.name === EBrowserType.Chrome &&
    Number.parseFloat(parserResults.browser.version) > 100
  );
}

export function isEdge(): boolean {
  return (
    parserResults.browser.name === EBrowserType.Edge &&
    Number.parseFloat(parserResults.browser.version) > 100
  );
}

export function isSafari(): boolean | undefined {
  return (
    parserResults.browser.name?.includes(EBrowserType.Safari) &&
    Number.parseFloat(parserResults.browser.version) > 14
  );
}
